import { render, staticRenderFns } from "./CadastroSectionLabel.vue?vue&type=template&id=c5e2857e&scoped=true&lang=pug&"
import script from "./CadastroSectionLabel.vue?vue&type=script&lang=js&"
export * from "./CadastroSectionLabel.vue?vue&type=script&lang=js&"
import style0 from "./CadastroSectionLabel.vue?vue&type=style&index=0&id=c5e2857e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e2857e",
  null
  
)

export default component.exports